/** Set on client/agency/admin login; WorkflowLayout consumes it once to open Home → Explore Sites. */
export const PENDING_HOME_LAUNCH_KEY = 'wf:pendingHomeLaunch';
/** User explicitly opened Dashboard in the sidebar — don't auto-bounce to Explore Sites. */
export const PREFER_DASHBOARD_KEY = 'wf:preferDashboard';

export function markPendingHomeLaunch(): void {
  try {
    sessionStorage.setItem(PENDING_HOME_LAUNCH_KEY, '1');
    sessionStorage.removeItem(PREFER_DASHBOARD_KEY);
  } catch {
    /* ignore */
  }
}

export function consumePendingHomeLaunch(): boolean {
  try {
    if (sessionStorage.getItem(PENDING_HOME_LAUNCH_KEY) !== '1') return false;
    sessionStorage.removeItem(PENDING_HOME_LAUNCH_KEY);
    return true;
  } catch {
    return false;
  }
}

export function clearPendingHomeLaunch(): void {
  try {
    sessionStorage.removeItem(PENDING_HOME_LAUNCH_KEY);
  } catch {
    /* ignore */
  }
}

/** Peek without consuming — used while waiting for project/onboarding data. */
export function hasPendingHomeLaunch(): boolean {
  try {
    return sessionStorage.getItem(PENDING_HOME_LAUNCH_KEY) === '1';
  } catch {
    return false;
  }
}

export function markPreferDashboard(): void {
  try {
    sessionStorage.setItem(PREFER_DASHBOARD_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearPreferDashboard(): void {
  try {
    sessionStorage.removeItem(PREFER_DASHBOARD_KEY);
  } catch {
    /* ignore */
  }
}

export function prefersDashboard(): boolean {
  try {
    return sessionStorage.getItem(PREFER_DASHBOARD_KEY) === '1';
  } catch {
    return false;
  }
}
